import React, { useState, useEffect } from 'reactn';
import Slider from 'react-slick';
import './slider.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lightbox from 'react-image-lightbox';
import '../lightbox.css'
import { GatsbyImage } from "gatsby-plugin-image"
import { Box } from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import Video from '../video';

const IngSlider = ({ images, title, }) => {
    const resizeRegex = /_[0-9]+x[0-9]+_/
    const lightboxSize = "_1024x1280_"
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false)
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    });
    console.log("IMG SLIDER", images)
    var imgData = []
    images.forEach(image => {
        var img = {}
        if (image.internal.type == "ShopifyVideo") {
            img = {
                type: "Video",
                altText: image.preview.image.altText,
                gatsbyImage: image.preview.image.gatsbyImageData,
                lightboxImage: image.preview.image.gatsbyImageData.images.fallback.src.replace(resizeRegex, lightboxSize),
                videoURL: image.sources[0].url.includes('mp4') ? image.sources[0].url : image.sources[1].url
            }
        } else {
            img = {
                type: "Image",
                altText: image.image.altText,
                gatsbyImage: image.image.gatsbyImageData,
                lightboxImage: image.image.gatsbyImageData.images.fallback.src.replace(resizeRegex, lightboxSize)
            }
        }
       
        imgData.push(img)
    });
    console.log("IMAGE DATA", imgData)
    const settingsMain = {
        dots: false,
        fade: false,
        infinite: true,
        speed: 650,
        autoplaySpeed: 3000,
        fadeIn: false,
        autoplay: false,
        pauseOnHover: true,
        asNavFor: '.slider-nav',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        lazyLoad: 'progressive',
        nextArrow: (
            <ArrowRightIcon w={4} h={4} color="brandWhite.200" />
        ),
        prevArrow: (
            <ArrowLeftIcon w={4} h={4} color="brandWhite.200" />
        ),
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                },
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 465,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                },
            },
        ],
    };

    const settingsThumbs = {
        slidesToShow: imgData.length,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        swipeToSlide: false,
        focusOnSelect: true,
        centerPadding: '0px'

    };

    function handleMoveNextRequest(e) {
        e && e.preventDefault();
        setPhotoIndex((photoIndex + 1) % images.length)
    }

    function handleMovePrevRequest(e) {
        e && e.preventDefault();
        setPhotoIndex((photoIndex + images.length - 1) % images.length)
    }

    function handleCloseModal(e) {
        e && e.preventDefault();
        setIsOpen(false)

    }

    function handleClickImage(e, index) {
        e && e.preventDefault();
        setPhotoIndex(index)
        setIsOpen(true)
    }
    console.log("imgData", imgData)

    return (
        <Box
            marginLeft={[0, 0, 10, 10]}
            marginRight={[0, 0, 10, 10]}
            className="slider-wrapper"
        >
            <Slider {...settingsMain}
                asNavFor={nav2}
                ref={slider => (setSlider1(slider))}
            >

                {imgData.map((image, index) => {
                    return (
                        <Box key={`img${index}`}
                            onClick={e => handleClickImage(e, index)} >
                            {image.type == "Image" ?
                                <GatsbyImage
                                    className="carouselImage"
                                    objectFit="contain"
                                    loading={index <= 2 ? "eager" : "lazy"}
                                    alt={image.altText}
                                    image={image.gatsbyImage}
                                />
                                :
                                <Video autoplay={true} alt={image.altText} title={image.altText} url={image.videoURL} draggable={false} />
                            }
                        </Box>



                    )
                })
                }
            </Slider>
            <Box className="thumbnail-slider-wrap" marginLeft={[0, 0, '20%']} marginRight={[0, 0, '20%']}>
                <Slider
                    {...settingsThumbs}
                    asNavFor={nav1}
                    ref={slider => (setSlider2(slider))}>
                    {imgData.map((image, index) => {
                        return (
                            <Box key={`tn${index}`} className="slick-slide" key={index} >
                                <GatsbyImage
                                    className="slick-slide-image"
                                    objectFit="contain"
                                    loading={index <= 4 ? "eager" : "lazy"}
                                    alt={image.altText}
                                    image={image.gatsbyImage}
                                />
                            </Box>

                        )
                    })}

                </Slider>
            </Box>
            {isOpen &&
                <Lightbox
                    mainSrc={imgData[photoIndex].lightboxImage}
                    nextSrc={imgData[(photoIndex + 1) % imgData.length].lightboxImage}
                    prevSrc={imgData[(photoIndex + imgData.length - 1) % imgData.length].lightboxImage}
                    onCloseRequest={handleCloseModal}
                    onMovePrevRequest={handleMovePrevRequest}
                    onMoveNextRequest={handleMoveNextRequest}
                />

            }
        </Box>
    )

}

export default IngSlider